import React from 'react'
import Navbar from './components/Navbar'
import News from './components/News'

export default function Home() {
  return (
    <div>
      <Navbar />
      <News/>
    </div>
  )
}
